// extracted by mini-css-extract-plugin
export default {"container":"User_container__DIQdw","body":"User_body__4edig","textName":"User_textName__zn1ko","textEmail":"User_textEmail__vmmfH","itemIconImg":"User_itemIconImg__0nL82"};